import React, { Fragment, useState, useEffect } from 'react';
import {
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
    Box,
    Grid
} from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from '../../../../component/cards/MainCard';

const ScaleInput = ({ questionnaireData }) => {
    const { scaleType = 'text', radioCount = 5 } = questionnaireData;

    const {
        options: passedOptions = [],
        minimumValue = 1,
        maximumValue = 5
    } = questionnaireData;

    const options =
        passedOptions.length > 0
            ? passedOptions
            : Array.from({ length: maximumValue - minimumValue + 1 }, (_, i) => {
                  const value = i + minimumValue;
                  return {
                      value,
                      label: value.toString()
                  };
              });

    return (
        <MainCard
            title={
                questionnaireData.questionNumber
                    ? `Questão ${questionnaireData.questionNumber}`
                    : null
            }
            sx={{ mb: 2 }}
        >
            <Box sx={{ p: 3 }}>
                <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
                    {questionnaireData.value}
                </Typography>
                <RadioGroup row={scaleType === 'numbers'}>
                    {options.map((option, i) => (
                        <FormControlLabel
                            key={i}
                            value={option.value}
                            control={
                                <Radio
                                    disabled
                                    checked={
                                        Number(option.value) ===
                                        Number(questionnaireData.answer)
                                    }
                                />
                            }
                            label={option.label}
                            labelPlacement={scaleType === 'numbers' ? 'top' : 'end'}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </MainCard>
    );
};

ScaleInput.propTypes = {
    questionnaireData: PropTypes.shape({
        id: PropTypes.any.isRequired,
        questionNumber: PropTypes.number,
        value: PropTypes.string,
        scaleType: PropTypes.string,
        radioCount: PropTypes.number,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                label: PropTypes.string
            })
        )
    }).isRequired,
    onInputChange: PropTypes.func.isRequired
};

export default ScaleInput;
